module.exports = __webpack_public_path__ + "img/Icon_SMS.6d32d0fc.svg";